import { FETCH_STEEL_SMELTER_LIST } from '../../actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_STEEL_SMELTER_LIST:
			return action.payload;
		default:
			return state;
	}
};
